/* eslint-disable jsx-a11y/anchor-is-valid */
import TextInput, { OpcionSelect } from "src/components/input/TextInput";
import { Box } from "@mui/system";
import { Form, Formik } from "formik";
import React from "react";
import {  Link, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { opcionesTipoDocumento } from "src/utils/constantes";
import {
  esquemaDeValidacionRegistroInternos,
  valoresInicialesRegistroInternos,
} from "./utils";

export interface FormularioUsuarioExternoProps {
  handleRegistro: (values: any) => void;
  verTerminosYcondiciones: () => void;
  cargandoPeticion: boolean;
  unidadesAcademicas: OpcionSelect[];
}

const FormularioUsuarioInterno = ({
  handleRegistro,
  verTerminosYcondiciones,
  cargandoPeticion,
  unidadesAcademicas,
}: FormularioUsuarioExternoProps) => {
  return (
    <Formik
      initialValues={valoresInicialesRegistroInternos}
      validationSchema={esquemaDeValidacionRegistroInternos}
      onSubmit={handleRegistro}
    >
      <Form autoComplete="off">
        <Box
          display="flex"
          sx={{
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 0, md: 2 },
          }}
        >
          <TextInput
            label="Tipo de identificación"
            name="tipoIdentificacion"
            type="select"
            opciones={opcionesTipoDocumento}
            data-testid="select-id"
          />
          <TextInput
            label="Número de identificación"
            name="identificacion"
            type="text"
          />
        </Box>
        <Box
          display="flex"
          sx={{
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 0, md: 2 },
          }}
        >
          <TextInput label="Nombres" name="nombres" type="text" />
          <TextInput label="Apellidos" name="apellidos" type="text" />
        </Box>
        <Box
          display="flex"
          sx={{
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 0, md: 2 },
          }}
        >
          <TextInput label="Celular" name="celular" type="text" />
          <TextInput
            label="Unidad Académica"
            name="unidadId"
            type="select"
            opciones={unidadesAcademicas}
            data-testid="select-id"
          />
        </Box>
        <TextInput
          label="Correo Institucional"
          name="correo"
          type="email"
          InputLabelProps={{ shrink: true }}
        />
        <TextInput
          label="Confirmar Correo Institucional"
          name="confirmarCorreo"
          type="email"
          InputLabelProps={{ shrink: true }}
        />
        <TextInput
          label="Correo personal"
          name="correoAlterno"
          type="email"
          InputLabelProps={{ shrink: true }}
        />
        <Typography align="right" variant="body2">
          ¿Ya tienes una cuenta?&nbsp;
          <Link href="/jupiter/" variant="body2">
            Inicia sesión
          </Link>
        </Typography>
        <Box display="flex" flexDirection="row" marginTop={2}>
          <Box
            display="flex"
            flexDirection="column"
            width="justifyContent"
            alignItems="center"
            paddingLeft={1}
          >
            <TextInput name="aceptaTerminos" label="" type="checkbox" />
          </Box>
          <Typography align="left" variant="body2" alignContent="center">
            Estoy de acuerdo con la{" "}
            <Link
              onClick={verTerminosYcondiciones}
              variant="body2"
              width="100%"
              align="left"
              alignContent="center"
              sx={{ cursor: "pointer" }}
            >
              política de privacidad
            </Link>
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap={2} marginTop={2}>
          <LoadingButton
            loading={cargandoPeticion}
            variant="contained"
            color="secondary"
            sx={{ color: "white" }}
            type="submit"
            data-testid="btn-resgistrarse"
          >
            Registrarse
          </LoadingButton>
        </Box>
      </Form>
    </Formik>
  );
};

export default FormularioUsuarioInterno;
